import { create } from 'zustand';
import { OrganizationDetails } from '@libs/models/settings';
import { Qualification } from '@libs/models/talents';
import { getDirectQualifications } from '@libs/api/talents';

type InitialState = {
  loading: boolean;
  data?: Qualification[];
  save: (settings: Omit<OrganizationDetails, 'id'>) => Promise<void>;
  load: () => void;
};

export const useDirectQualificationsStore = create<InitialState>()((set) => ({
  loading: false,
  save: async (settings) => {},
  load: async () => {
    set({ loading: true });
    try {
      const list = await getDirectQualifications();
      set({ loading: false, data: list });
    } finally {
      set({ loading: false });
    }
  },
}));
